import React from 'react';
import { Link } from 'react-router-dom';
import Banner from '../Banner/Banner';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';

interface ReportingPausedBannerProps {
  className?: string;
}

export const ReportingPausedBanner: React.FC<ReportingPausedBannerProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Banner
      variant="warning"
      automation="on"
      size="compact"
      showBar={false}
      title={t(TranslationKeyEnum.ReportingPausedBannerTitle)}
      subtitle={
        <>
          {t(TranslationKeyEnum.ReportingPausedBannerSubtitlePrefix)}{' '}
          <Link to="/help" className="underline font-bold text-black-800 hover:text-black-600">
            {t(TranslationKeyEnum.ContactHills)}
          </Link>{' '}
          {t(TranslationKeyEnum.ReportingPausedBannerSubtitleSuffix)}
        </>
      }
      className={className}
    />
  );
};
